module.exports = __webpack_public_path__ + "img/logo.ded02a8f.png";